
import { scrollIntoView } from '@/Utils/directives'
import { isYearInArray, isMonthInArray, parseDate, compareMonth } from '@/components/common/Date/Utils/helpers'
import Button from '@/components/UntitledUI/Button.vue'
import HeadlessCalendar from '@/components/common/Date/HeadleesCalendar.vue'
import CalendarDate from '@/components/common/Date/Instance/CalendarDate'

export default {
    name: 'Calendar',
    directives: {
        scrollIntoView
    },
    components: {
        HeadlessCalendar,
        Button
    },
    props: {
        value: {
            type: [String, Date],
            default: null
        },
        defaultDate: {
            type: [String, Date],
            default: null
        },
        locale: {
            type: Object,
            default: () => ({})
        },
        calendarClass: {
            type: null,
            default: () => CalendarDate
        },
        minDate: {
            type: [String, Date],
            default: null
        },
        maxDate: {
            type: [String, Date],
            default: null
        },
        enabledDates: {
            type: Array,
            default: null
        },
        disabledDates: {
            type: Array,
            default: null
        }
    },
    data () {
        return {
            view: 'calendar',
            dateValue: this.value
        }
    },
    computed: {
        years () {
            const yearBounds = this.calendarClass.getCalendarYearBounds()
            const diff = yearBounds[1] - yearBounds[0]
            const years = []
            const minDate = parseDate(this.minDate)
            const maxDate = parseDate(this.maxDate)
            for (let i = 0; i <= diff; i++) {
                const year = yearBounds[0] + i
                if (minDate instanceof Date && year < minDate.getFullYear()) {
                    continue
                }
                if (maxDate instanceof Date && year > maxDate.getFullYear()) {
                    continue
                }
                if (Array.isArray(this.enabledDates) && !isYearInArray(year, this.enabledDates)) {
                    continue
                }
                if (Array.isArray(this.enabledDates) && isYearInArray(year, this.disabledDates)) {
                    continue
                }
                years.push(year)
            }
            return years
        }
    },
    watch: {
        value () {
            this.dateValue = this.value
        }
    },
    methods: {
        changeMonth (setMonth, month) {
            setMonth(month)
            this.view = 'calendar'
        },
        changeYear (setYear, year) {
            setYear(year)
            this.view = 'month'
        },
        getYearMonths (year) {
            const months = []
            const minDate = parseDate(this.minDate)
            const maxDate = parseDate(this.maxDate)
            for (let i = 0; i < 12; i++) {
                const date = new Date(year, i, 1)
                if (minDate instanceof Date && compareMonth(date, minDate) < 0) {
                    months.push(false)
                } else if (maxDate instanceof Date && compareMonth(date, maxDate) > 0) {
                    months.push(false)
                } else if (Array.isArray(this.enabledDates) && !isMonthInArray(i, year, this.enabledDates)) {
                    months.push(false)
                } else if (Array.isArray(this.enabledDates) && isMonthInArray(i, year, this.disabledDates)) {
                    months.push(false)
                } else {
                    months.push(true)
                }
            }
            return months
        },
        /**
         * @param {CalendarDate} date
         */
        updateDate (date) {
            this.dateValue = `${date.year}-${String(date.month + 1).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`
            this.$emit('input', this.dateValue)
            this.$emit('change', this.dateValue)
        }
    }
}
